import { createContext } from "react";
import { ModalType } from "../../types/ModalType.ts";

type ModalContextType = {
  openModalType: ModalType | null;
  openModal: (type: ModalType) => void;
  closeModal: () => void;
};

export const ModalContext = createContext<ModalContextType | undefined>(
  undefined,
);
